module.exports = __webpack_public_path__ + "assets/img/notfifications-bell.svg";